module.exports = __webpack_public_path__ + "5e71da728d9b83c8116badf6a3b74dca.png";